import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

type Props = {
  pullDistance: number;
  refreshing: boolean;
};

const NativePullToRefreshIndicator = ({ pullDistance, refreshing }: Props) => {
  if (pullDistance <= 0 && !refreshing) return null;

  const ready = pullDistance >= 72;

  return (
    <div
      className="native-ptr-indicator pointer-events-none fixed left-0 right-0 z-[60] flex justify-center"
      style={{
        top: "calc(var(--native-safe-top, 0px) + var(--native-header-height, 3.5rem))",
        opacity: refreshing ? 1 : Math.min(1, pullDistance / 56),
      }}
    >
      <div className="native-ptr-indicator-inner">
        <Loader2
          className={cn(
            "native-ptr-icon",
            (refreshing || ready) && "is-refreshing",
          )}
          strokeWidth={2.5}
        />
      </div>
    </div>
  );
};

export default NativePullToRefreshIndicator;
